import { Module, VuexModule, Mutation, Action } from "vuex-module-decorators";
import { updateUser, meInfo, passwordUpdate } from "../../services/user";

@Module({
  namespaced: true,
})
export default class ProfileUpdate extends VuexModule {
  // state
  meTenant = null;
  extendedData = {};
  @Action
  public async updateTenant(payload) {
    try {
      const data = await updateUser("partner", payload.id, payload.data);
      return data;
    } catch (error) {
      throw error;
    }
  }
  @Action
  public async UpdatePassword(payload) {
    try {
      const data = await passwordUpdate("partner", payload);
      return data;
    } catch (error: any) {
      throw new Error(error.response);
    }
  }
  @Action
  public async updateTenantPassword(payload) {
    try {
      const data = await passwordUpdate("tenant", payload);
      return data;
    } catch (error: any) {
      throw new Error(error.response);
    }
  }
  @Action
  public async fetchmeTenant(payload) {
    try {
      const data = await meInfo("partner");
      this.context.commit("setmeTenant", data.response.user);
      let extendedData = {}
      if (data.response.user.extendedAttributes) {
        for (const [key, value] of Object.entries(
          data.response.user.extendedAttributes
        )) {
          if (key == "firstLogin") continue;
          if (typeof value == 'object') continue
          extendedData[key] = value;
        }
      }
      this.context.commit("setExtendedData", extendedData)

      return data;
    } catch (error) {
      // throw error
    }
  }
  // mutations

  @Mutation
  public setmeTenant(data: any) {
    this.meTenant = data;
  }
  @Mutation
  public setExtendedData(data: any) {
    this.extendedData = data;
  }
  // getters
  get GetmeTenant() {
    return this.meTenant;
  }
}
